import { useEffect, useState } from 'react'

import { setContactsCardsStatus } from '@/client/generalSlice'
import { useAppDispatch, useAppSelector } from '@/client/hooks'

const useCardsCollapseStatus = (isInitiallyExpanded) => {
  const dispatch = useAppDispatch()

  const generalStatus = useAppSelector((state) => state.general.contactsCardsStatus)
  const [isExpanded, setIsExpanded] = useState<boolean>(isInitiallyExpanded)

  const toggleIsExpanded = () => {
    dispatch(setContactsCardsStatus('custom'))
    setIsExpanded((isExpanded) => !isExpanded)
  }

  useEffect(() => {
    if (generalStatus !== 'custom') {
      setIsExpanded(generalStatus === 'allExpanded')
    }
  }, [generalStatus])

  return { isExpanded, toggleIsExpanded }
}

export default useCardsCollapseStatus
